































import { computed, defineComponent, PropType } from "@vue/composition-api";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { ContentFeedSearchResult } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import BasePage from "@/components/BasePage";
import ContentFeedView from "@/components/ContentFeedView";
import GalleryFilters from "@/components/GalleryFilters";
import PageTitle from "@/components/PageTitle";
import { getFilterItems } from "../../const";

export default defineComponent({
  name: "LikedContentView",
  components: { GalleryFilters, ContentFeedView, BasePage, PageTitle },
  props: {
    feedId: { type: String },
    type: { type: String },
    loading: { type: Boolean, default: false },
    data: { type: Object as PropType<ContentFeedSearchResult> },
    followedUserIds: { type: Object as () => Record<string, boolean>, required: true },
    paymentPackages: { type: Array as () => PaymentPackage[], required: true },
    enableScroll: { type: Boolean, default: true },
  },
  setup(props, { root }) {
    const isFeedView = computed(() => !!props.feedId);
    const filterItems = computed(() => getFilterItems());

    const toggleView = () => {
      if (!props.data?.result.length) return;
      if (isFeedView.value) {
        root.$router.replace({ name: "likedContent", query: { type: props.type } });
      } else {
        const id = !!props.feedId ? props.feedId : props.data.result[0].id;
        root.$router.push({ name: "likedContent", query: { type: props.type, id } });
      }
    };

    const onGridItemClick = (id: string) => {
      root.$router.push({ name: "likedContent", query: { type: props.type, id } });
    };

    return { filterItems, isFeedView, toggleView, onGridItemClick };
  },
});
